package fr.frux.splash

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Path
import androidx.compose.ui.graphics.drawscope.DrawScope
import androidx.compose.ui.graphics.drawscope.scale
import androidx.compose.ui.graphics.drawscope.translate
import androidx.compose.ui.graphics.drawscope.withTransform
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.graphics.vector.PathParser
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.Density
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import fr.frux.app.resources.splash_tagline
import fr.frux.core.designsystem.resources.Res
import fr.frux.core.designsystem.resources.figtree_medium
import fr.frux.core.designsystem.resources.sora_bold
import org.jetbrains.compose.resources.Font
import org.jetbrains.compose.resources.stringResource
import fr.frux.app.resources.Res as AppRes

private val INK = Color(0xFF223F2B)
private val MOUSSE = Color(0xFF628862)
private val ARGILE = Color(0xFFC4733D)
private val SAUGE = Color(0xFFAFBDAA)

// Paths du design Claude (splash.jsx), viewBox 390 280 1270 1460.
// Données SVG insécables : la limite de longueur de ligne ne s'applique pas.
@Suppress("ktlint:standard:max-line-length")
private const val D_PIN = "M678.9 1186c28.1 10.6 59.3 11.5 88.8 8.2 41.4 89.9 115.2 183 189.3 248.2 10.8 10.7 52.5 43.6 67 43.6 17.5 0 53-30.5 66.6-42.7 11.9-9.2 31-28.1 41.7-39a779 779 0 0 0 149.6-210.6 192 192 0 0 0 88.2-7.2q-6 17.5-13.4 34.3a530 530 0 0 1-31.8 59.9c-61.2 100.8-132 203.8-199 301l-51.8 75c-8.6 12.6-27.2 44.7-40.7 49.4a27 27 0 0 1-20.6-1.3c-10.3-5-31.7-40-39.5-51.4l-59.8-86.8q-74.7-107.4-145.6-217.3c-16.1-25.2-33.9-52.3-48.9-78a515 515 0 0 1-40-85.3"

@Suppress("ktlint:standard:max-line-length")
private const val D_CROWN = "M967 1160.8c-42 15.4-81.8 13.3-124.4-.4-9-3-21.5-10.7-30.3-11.3-11.4-.3-24 3.5-35 6-81.2 18.5-175.2-27-197.1-110.5-4-15.3-5-33.2-12.7-47-5.7-10.4-18.7-18.8-26.6-27.6a196 196 0 0 1-34.8-54c-32.9-75.7-13.3-144 39-205.3 10.3-12.1 32-32.8 38.5-44.6 5.5-10 6.3-41.6 8.3-54.1 3.3-20.3 7-38 14.5-57.4 31.7-81.2 97.2-114 179.7-123.8 15.9-1.9 41-1.5 54.4-5.7 8.6-2.6 27.5-22.3 36.6-29.7q26.1-21.3 57-35.2c84.1-37 180.2-17.6 247.6 43.2 21.4 19.3 23 26.7 54.8 25 5.7-.2 16.2.7 22.2 1.2q39.2 3 75.8 17.4c76.6 30.2 110 86.7 121.8 165.7 2.4 16.5 3.4 41.2 10.4 55.4s23.8 27.7 34.7 39.1c16 17 32.5 37.5 41.6 59.2 20.1 48 21.5 97.5-1.9 144.5-8.1 16.4-17.8 27.4-27.9 41.6-8.8 12.4-22.3 21.4-28.8 32.7-6.3 11-8 32.4-10.5 45.4q-2.8 14.6-8.4 28.3c-25.6 63-94.8 102-161.7 99.6q-14.9-.5-29.3-3.3c-8.3-1.6-31.8-9.3-37.4-7.1-51.5 19.8-100 34.8-155.5 11.6-7.2 14.5-13.7 61.5-13.7 77.5 0 33 3 70.8 7 103.8 3.7 30.5 8.4 72.2 15.7 102.3-13.5 12.2-49.1 42.6-66.6 42.7-14.5 0-56.2-33-67-43.6q8.6-62.4 11.7-125.2c3.6-61.5 5.8-94-1.7-156.4"

@Suppress("ktlint:standard:max-line-length")
private const val D_BRANCHES = "M998.1 881.1c12-34.4 22.6-65.5 41.9-96.7 24.7-40.2 54-69.6 71.1-114.6a493 493 0 0 0 27.8-118.7c1.1-9.3.8-41.8 7.9-45.4 18.3-9.5 17.2 18.1 17.6 28.5 1.7 44.5-5.4 88.8-12 132.6a11 11 0 0 0 .7 7.1c.9 0 54.5-31.8 61.7-35.2 15.8-7.4 97-43.4 109.6-41.1 4.7 3 8.8 11.8 4.9 15.9-6.9 7-21.7 11.6-30.8 15.8-60.2 28.3-130.3 64.6-175.7 114.7-68.8 75.9-89.2 185.3-81.3 284.7 1.2 14 1.3 40.9 4.8 53.7 4 2 8.9-3.7 11.5-6.5a476 476 0 0 1 127.3-93.7c58.2-29.4 116-54.5 166.5-97 9-7.5 35-34.3 43.2-37 6 1 9.3 4.9 9.8 10.8-3 10-12.6 20-19.5 27.7-63.4 71.2-155.3 107-228.5 166-26.8 21.7-69.1 72.3-75 107-7.2 14.5-13.7 61.5-13.7 77.5 0 33 3 70.8 7 103.8 3.7 30.5 8.4 72.2 15.7 102.3-13.5 12.2-49.1 42.6-66.6 42.7-14.5 0-56.2-33-67-43.6q8.6-62.4 11.7-125.2c3.6-61.5 5.8-94-1.7-156.4.4-12.4-9.7-46.5-14.6-58.3q-9-21.7-23.4-40.4c-29.7-38.2-90.4-86.7-132-112.3a517 517 0 0 0-111.6-48.2c-10.5-3.2-20.9-6.1-31.3-9.7-11.2-3.8-11.4-17.7-3-19 15.1-2.6 37.7 4.2 53.1 7.8C783.5 899.2 862 931.2 926 982.5c14.3 11.5 28 22.7 43.8 31.1 4-76-46-156.8-87.3-218.4-38-56.8-68.1-121-86.8-187.2-2-7.3 13-16.8 19.3-4.2 7.6 15.3 14 31.5 21.9 46.8q25.8 51.2 60 97.2c11.2 15.3 23.1 29.7 34.6 44.7z"

@Suppress("ktlint:standard:max-line-length")
private const val D_LEAVES = "M1277.5 661.2q1.6-.2 3.4.1c5 6.3-1.5 23-5.4 29-7.2 11-15.6 14.8-28 17.5l-2.6-.6c-8.6-13.6 6-35.3 18.4-41.5 5.1-2.5 8.8-3.4 14.2-4.5m-207.7-219.1 4.2-.1c5.5 3.9 2 12.3-.3 17.2-6 12.8-12.6 17.6-25.2 22-2.5.3-2.4.3-5 0-8.6-9.2 6-29.6 14.6-34.4a47 47 0 0 1 11.7-4.7"
private val FRUIT_PATHS =
    listOf(
        "M1232.3 714.3a80.1 80.1 0 1 1 25.4 158.1 80.1 80.1 0 0 1-25.4-158.1" to Offset(1245f, 793f),
        "M1039 488a63.7 63.7 0 1 1 7.2 127.2 63.7 63.7 0 0 1-7.1-127.1" to Offset(1042.6f, 551.6f),
        "M724.7 637.3A63.3 63.3 0 1 1 740.5 763a63.3 63.3 0 0 1-15.8-125.7" to Offset(732.6f, 700.2f),
        "M1369.4 941.3a63.3 63.3 0 1 1 22.2 124.6 63.3 63.3 0 0 1-22.2-124.6" to Offset(1380.5f, 1003.6f),
        "M762 978.1a63.2 63.2 0 1 1 22.8 124.4A63.2 63.2 0 0 1 762 978" to Offset(773.4f, 1040.3f),
    )

// viewBox du SVG d'origine
private const val VB_X = 390f
private const val VB_Y = 280f
private const val VB_W = 1270f
private const val VB_H = 1460f
private const val AUTHORED_SIZE = 720f // taille de composition du design (settle/name en px de cet espace)

// Dimensionnement responsive (#201) : 280.dp reste le nominal en portrait, mais un conteneur bas
// (paysage téléphone) doit pouvoir réduire le logo plutôt que déborder.
private val NOMINAL_LOGO_SIZE = 280.dp
private val MIN_LOGO_SIZE = 160.dp

// Budget vertical approximatif pris par la remontée du logo + le nom + la signature sous le canvas,
// à l'échelle nominale (mesuré sur le design : ~373 dp de hauteur totale pour un canvas de 280 dp).
private val TEXT_BLOCK_RESERVE = 93.dp

// Plafond de fontScale système appliqué à la typo du splash : au-delà, on préfère un texte moins
// agrandi qu'un débordement (le splash n'est affiché que 2,4 s, ce n'est pas un écran de lecture).
private const val MAX_FONT_SCALE = 1.3f

/** Logo au nominal (280.dp) tant que la hauteur disponible le permet, réduit sinon. Pure, testable. */
internal fun splashLogoSize(maxHeight: Dp): Dp {
    val available = maxHeight - TEXT_BLOCK_RESERVE
    return minOf(NOMINAL_LOGO_SIZE, available).coerceAtLeast(MIN_LOGO_SIZE)
}

/** Borne le fontScale système utilisé par la typo du splash. Pure, testable. */
internal fun splashFontScale(systemFontScale: Float): Float = systemFontScale.coerceIn(0f, MAX_FONT_SCALE)

private fun parse(d: String): Path = PathParser().parsePathString(d).toPath()

/** Paths du logo, parsés une seule fois par composition qui les dessine. */
private class LogoPaths {
    val pin = parse(D_PIN)
    val crown = parse(D_CROWN)
    val branches = parse(D_BRANCHES)
    val leaves = parse(D_LEAVES)
    val fruits = FRUIT_PATHS.map { (d, c) -> parse(d) to c }
}

/** Dessine le logo (pin et arbre) dans la frame donnée, centré et mis à l'échelle de la zone. */
private fun DrawScope.drawLogo(
    frame: SplashFrame,
    paths: LogoPaths,
) {
    val s = minOf(size.width / VB_W, size.height / VB_H)
    withTransform({
        translate((size.width - VB_W * s) / 2f, (size.height - VB_H * s) / 2f)
        scale(s, s, pivot = Offset.Zero)
        translate(-VB_X, -VB_Y)
    }) {
        // Pin : chute + écrasement autour de sa base (1024, 1560)
        translate(top = frame.pinOffsetY) {
            scale(1f, frame.pinSquash, pivot = Offset(1024f, 1560f)) {
                drawPath(paths.pin, SAUGE, alpha = frame.pinAlpha)
            }
        }
        // Arbre : tout pousse depuis le sommet du pin (1024, 1465)
        scale(frame.crownScale, frame.crownScale, pivot = Offset(1024f, 1465f)) {
            drawPath(paths.crown, INK)
            scale(frame.branchScale, frame.branchScale, pivot = Offset(1024f, 1100f)) {
                drawPath(paths.branches, MOUSSE, alpha = frame.branchAlpha)
            }
            scale(frame.leafScale, frame.leafScale, pivot = Offset(1130f, 550f)) {
                drawPath(paths.leaves, MOUSSE, alpha = frame.leafAlpha)
            }
            paths.fruits.forEachIndexed { i, (path, c) ->
                val fs = frame.fruitScales[i]
                if (fs > 0f) scale(fs, fs, pivot = c) { drawPath(path, ARGILE) }
            }
        }
    }
}

/**
 * Le logo seul, sans nom ni signature, figé sur la frame finale du splash (#492) : l'accueil le
 * montre en tête plutôt qu'un pictogramme générique. Sa palette est fixe, il se pose donc sur le
 * fond crème [FOND_SPLASH] et jamais sur une couleur du thème.
 */
@Composable
fun FruxLogoMark(modifier: Modifier = Modifier) {
    val paths = remember { LogoPaths() }
    val frame = remember { SplashTimeline.at(SplashTimeline.TOTAL) }
    Canvas(modifier) { drawLogo(frame, paths) }
}

/**
 * Mémoïse la frame du tick courant : les phases draw/placement lisent toutes le même t dans une
 * frame donnée, une seule évaluation de [SplashTimeline.at] (et son allocation) suffit.
 */
private class FrameCache {
    private var lastT = Float.NaN
    private var frame = SplashTimeline.at(0f)

    fun at(t: Float): SplashFrame {
        if (t != lastT) {
            frame = SplashTimeline.at(t)
            lastT = t
        }
        return frame
    }
}

// [t] est une lambda lue uniquement en phase draw/placement : l'animation ne recompose ni ne
// remesure rien, elle redessine (perf splash — les paths, eux, sont parsés une seule fois).
@Composable
fun FruxSplashLogo(
    t: () -> Float,
    modifier: Modifier = Modifier,
    logoSize: Dp? = null,
) {
    val frameCache = remember { FrameCache() }
    val paths = remember { LogoPaths() }

    val sora = FontFamily(Font(Res.font.sora_bold, FontWeight.Bold))
    val figtree = FontFamily(Font(Res.font.figtree_medium, FontWeight.Medium))

    BoxWithConstraints(modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
        val resolvedLogoSize = logoSize ?: splashLogoSize(maxHeight)
        val k = resolvedLogoSize.value / AUTHORED_SIZE // px auteur -> dp
        // Typo à sa taille de design tant que le logo est au nominal ; ne rétrécit qu'avec lui (#201).
        val textK = resolvedLogoSize.value / NOMINAL_LOGO_SIZE.value
        val baseDensity = LocalDensity.current
        val cappedDensity =
            remember(baseDensity) {
                Density(baseDensity.density, splashFontScale(baseDensity.fontScale))
            }

        CompositionLocalProvider(LocalDensity provides cappedDensity) {
            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                modifier =
                    Modifier.graphicsLayer {
                        translationY = (frameCache.at(t()).settleOffsetY * k).dp.toPx()
                    },
            ) {
                Canvas(Modifier.size(resolvedLogoSize)) {
                    drawLogo(frameCache.at(t()), paths)
                }
                // Toujours composés (alpha 0 avant leur entrée) : la visibilité se joue en phase
                // draw, pas en composition — sinon leur apparition recomposerait en pleine animation.
                Text(
                    "Frux",
                    fontFamily = sora,
                    fontWeight = FontWeight.Bold,
                    fontSize = (56 * textK).sp,
                    color = INK,
                    modifier =
                        Modifier.graphicsLayer {
                            val frame = frameCache.at(t())
                            alpha = frame.nameAlpha
                            translationY = (frame.nameOffsetY * k).dp.toPx()
                        },
                )
                Text(
                    stringResource(AppRes.string.splash_tagline),
                    fontFamily = figtree,
                    fontWeight = FontWeight.Medium,
                    fontSize = (14 * textK).sp,
                    color = MOUSSE,
                    letterSpacing = 0.2.sp,
                    modifier =
                        Modifier.graphicsLayer {
                            val frame = frameCache.at(t())
                            alpha = frame.tagAlpha
                            translationY = (frame.tagOffsetY * k).dp.toPx()
                        },
                )
            }
        }
    }
}
